import * as Yup from "yup";

//const phoneRegExp = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/
//const urlRegExp = /(http(s?):)([/|.|\w|\s|-])*\.(?:gif|jpe?g|tiff?|png|webp|bmp)$/

export const validationSchema = Yup.object().shape({
  businessName: Yup.string().required("Business Name is Required"),
  serviceName: Yup.string().required("Service Queue Name is Required"),
});
